/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Podcast = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "11", r: "1" }],
    ["path", { d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z" }],
    ["path", { d: "M8 14a5 5 0 1 1 8 0" }],
    ["path", { d: "M17 18.5a9 9 0 1 0-10 0" }]
  ]
];

export { Podcast as default };
//# sourceMappingURL=podcast.js.map
